import { type FC, type ReactNode } from 'react';
import {
  UiStack,
  type UiStackProps,
  uiStyles,
} from '@/lib/ui';

export interface CardGroupProps extends UiStackProps {
}

export const CardGroup: FC<CardGroupProps> = ({
  ...props
}) => {
  return (
    <UiStack
      borderRadius={uiStyles.borderRadius}
      shadow={uiStyles.cardShadow}
      bgColor={'#fff'}
      {...props}
    />
  );
};

export default CardGroup;
